import { useEffect } from 'react'
import Rodal from 'rodal'
import { CloseIcon } from 'components/icons'
import 'rodal/lib/rodal.css'

type Props = {
  isOpen: boolean
  closeModal: React.MouseEventHandler<HTMLSpanElement>
  children: JSX.Element
  className?: string
  titleClassname?: string
  title?: string
  height?: number
  width?: number
  closeOnEsc?: boolean
  closeMaskOnClick?: boolean
  customStyle?: Record<string, any>
}

const Modal = ({
  children,
  title = '',
  isOpen,
  closeModal,
  className = '',
  titleClassname = '',
  height,
  width,
  closeMaskOnClick = true,
  closeOnEsc = true,
  customStyle,
}: Props) => {
  // disable scroll of body when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'auto'
    }
  }, [isOpen])

  return (
    <Rodal
      visible={isOpen}
      onClose={closeModal}
      animation="slideDown"
      closeOnEsc={closeOnEsc}
      closeMaskOnClick={closeMaskOnClick}
      className={className}
      showCloseButton={false}
      customStyles={{
        height: height ? height + 'px' : 'max-content',
        maxHeight: '90vh',
        width: width ? width + 'px' : 'max-content',
        maxWidth: '90vw',
        minWidth: '300px',
        overflowY: 'auto',
        padding: '30px',
        ...customStyle,
      }}
    >
      {/* Close Button */}
      <button
        type="button"
        onClick={closeModal}
        className="absolute right-5 top-5 z-50 flex h-3 w-3"
      >
        <CloseIcon />
      </button>

      {/* Title */}
      {title && (
        <h3
          className={`mb-3 border-b-2 border-[#E5E5E5] pb-3 pr-7 text-xl font-semibold ${titleClassname}`}
        >
          {title}
        </h3>
      )}

      {/* Modal Content */}
      {children}
    </Rodal>
  )
}

export default Modal
